import React from 'react';
import { useTranslation } from 'react-i18next';

interface NoteContentProps {
  content: string;
  maxLength: number;
  onChange: (content: string) => void;
}

export default function NoteContent({ content, maxLength, onChange }: NoteContentProps) {
  const { t } = useTranslation('createNote');
  const remainingChars = maxLength - content.length;
  const isOverLimit = remainingChars < 0;

  return (
    <div className="space-y-2">
      <div className="flex justify-between items-center">
        <label className="block text-sm font-medium text-gray-700">
          {t('form.content.label')}
        </label>
        <span className={`text-sm font-medium ${
          isOverLimit ? 'text-red-600' :
          remainingChars < 1000 ? 'text-orange-600' :
          'text-gray-500'
        }`}>
          {t('form.content.remaining', { count: remainingChars })}
        </span>
      </div>
      <textarea
        value={content}
        onChange={(e) => onChange(e.target.value)}
        maxLength={maxLength}
        className={`w-full h-48 p-4 border rounded-xl focus:outline-none focus:ring-2 transition duration-200 text-base resize-none ${
          isOverLimit
            ? 'border-red-300 focus:ring-red-200 focus:border-red-400'
            : remainingChars < 1000
            ? 'border-orange-300 focus:ring-orange-200 focus:border-orange-400'
            : 'border-gray-200 focus:ring-blue-500 focus:border-transparent'
        }`}
        placeholder={t('form.content.placeholder')}
      />
    </div>
  );
}